import { useEffect, useState } from "react";
import { Loading } from "@components";
import { message } from "antd";
import { Navigate } from "react-router-dom";
import * as API from "@api";

export default function NewPage() {
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!data) {
      API.ArticleCategories.create({
        name: `New Article Category`,
        country_id: 1,
      })
        .then((res) => {
          if (!res || res?.error) {
            throw new Error("Error while creating category");
          }

          setData(res?.data);
        })
        .catch((err) => {
          return message.error(
            err?.message || "Error while creating category",
            2
          );
        });
    }
  }, [data]);

  if (data?.id) {
    return <Navigate to={`/article_categories/edit/${data?.id}`} />;
  }

  return <Loading />;
}
